/* eslint-disable no-lonely-if */
const tileTagging = () => {

    const pageTypeIdentifier = document.querySelector('#page-type-identifier');

    if (window.obDatas) {

        const contentTags = window.obDatas.contentTags;
        const paintTags = window.obDatas.painPointTags;

        if (contentTags && paintTags) {
            const contentKeys = Object.keys(contentTags);
            const painKeys = Object.keys(paintTags);

            let tiles = document.querySelectorAll('#collection-items ul li.tile');

            const arrowSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="19.585" height="14" viewBox="0 0 19.585 14">
      <path id="Path_1005" data-name="Path 1005" d="M43.9,27.969l5.013-5.24V40.651h1.045V22.728l5.013,5.24,1.464-.014-6.623-6.889h-.754l-6.623,6.889Z" transform="translate(40.651 -42.435) rotate(90)" fill="#fff"/>
    </svg>
    `;

            if (pageTypeIdentifier && pageTypeIdentifier.getAttribute('data-page-type') === 'PAGE_TYPE_ITEM') {
                tiles = document.querySelectorAll('#related-items-carousel .carousel-inner div.tile');
                tiles.forEach((tile) => {
                    if (!tile.classList.contains('ob-custom-tile')) {
                        let tileContentTag = '';
                        const tilePainTags = [];
                        const dataTags = tile.getAttribute('data-tags');
                        if (dataTags) {
                            //check tile if it has a content tag, then change content tag to match backend
                            contentKeys.forEach((key) => {
                                if (dataTags.search(key) !== -1) {
                                    tileContentTag = contentTags[key];
                                }
                            });

                            //check tile if it has pain point tag, then add to array
                            painKeys.forEach((key) => {
                                if (dataTags.search(key) !== -1) {
                                    tilePainTags.push(paintTags[key]);
                                }
                            });
                        }

                        const contentTag = document.createElement('div');
                        const paintContainer = document.createElement('div');

                        const paintTagList = document.createElement('ul');
                        paintTagList.classList.add('paintTagContainer');

                        const timeTag = tile.querySelector(' .description .friendly-timestamp');

                        const arrowContainer = document.createElement('div');
                        arrowContainer.insertAdjacentHTML('beforeend', arrowSVG);
                        arrowContainer.classList.add('arrowContainer');
                        paintContainer.appendChild(arrowContainer);

                        contentTag.innerHTML = tileContentTag;
                        contentTag.classList.add('content-tag');

                        if (timeTag) {


                            if (tilePainTags.length !== 0) {
                                tilePainTags.forEach((painTag) => {
                                    const tag = document.createElement('li');
                                    tag.appendChild(document.createTextNode(painTag));
                                    tag.classList.add('paintTag');
                                    paintTagList.appendChild(tag);
                                });

                                paintContainer.appendChild(paintTagList);
                            }
                            paintContainer.classList.add('paint-content-container');
                            timeTag.parentNode.insertBefore(paintContainer, timeTag);
                            timeTag.parentNode.replaceChild(contentTag, timeTag);
                        } else {

                            const tileDescription = tile.querySelector('.description .h3like');
                            if (tileDescription) {
                                if (tilePainTags.length !== 0) {
                                    tilePainTags.forEach((painTag) => {
                                        const tag = document.createElement('li');
                                        tag.appendChild(document.createTextNode(painTag));
                                        tag.classList.add('paintTag');
                                        paintTagList.appendChild(tag);
                                    });
                                    paintContainer.classList.add('paint-content-container');
                                    paintContainer.appendChild(paintTagList);
                                    tileDescription.parentNode.insertBefore(paintContainer, tileDescription);
                                    tileDescription.parentNode.insertBefore(contentTag, tileDescription);
                                }
                                tileDescription.parentNode.insertBefore(contentTag, tileDescription);
                                tileDescription.parentNode.insertBefore(paintContainer, tileDescription);
                                tile.classList.add('ob-custom-tile');
                                paintContainer.appendChild(arrowContainer);
                            }
                        }
                    }
                });
            } else {
                tiles.forEach((tile) => {
                    if (!tile.classList.contains('ob-custom-tile')) {
                        let tileContentTag = '';
                        const tilePainTags = [];
                        const dataTags = tile.getAttribute('data-tags');
                        if (dataTags) {
                            //check tile if it has a content tag, then change content tag to match backend
                            contentKeys.forEach((key) => {
                                if (dataTags.search(key) !== -1) {
                                    tileContentTag = contentTags[key];
                                }
                            });

                            //check tile if it has pain point tag, then add to array
                            painKeys.forEach((key) => {
                                if (dataTags.search(key) !== -1) {
                                    tilePainTags.push(paintTags[key]);
                                }
                            });
                        }

                        //create new elements
                        const contentTag = document.createElement('div');
                        const paintContainer = document.createElement('div');

                        const paintTagList = document.createElement('ul');
                        paintTagList.classList.add('paintTagContainer');

                        const timeTag = tile.querySelector('li .description .friendly-timestamp');

                        if (timeTag) {
                            contentTag.innerHTML = tileContentTag;
                            contentTag.classList.add('content-tag');

                            if (tilePainTags.length !== 0) {
                                tilePainTags.forEach((painTag) => {
                                    const tag = document.createElement('li');
                                    tag.appendChild(document.createTextNode(painTag));
                                    tag.classList.add('paintTag');
                                    paintTagList.appendChild(tag);
                                });
                            }

                            const arrowContainer = document.createElement('div');
                            arrowContainer.insertAdjacentHTML('beforeend', arrowSVG);
                            arrowContainer.classList.add('arrowContainer');
                            paintContainer.appendChild(arrowContainer);
                            paintContainer.appendChild(paintTagList);
                            paintContainer.classList.add('paint-content-container');
                            timeTag.parentNode.insertAdjacentElement('beforeend', paintContainer);

                            timeTag.parentNode.replaceChild(contentTag, timeTag);
                        } else {
                            tile.classList.add('no-time-tag');
                            if (!tile.classList.contains('cta')) {
                                contentTag.innerHTML = tileContentTag;
                                contentTag.classList.add('content-tag');

                                paintContainer.classList.add('paint-content-container');

                                const tileDescription = tile.querySelector('.description .h3like');
                                if (tilePainTags.length !== 0) {
                                    tilePainTags.forEach((painTag) => {
                                        const tag = document.createElement('li');
                                        tag.appendChild(document.createTextNode(painTag));
                                        tag.classList.add('paintTag');
                                        paintTagList.appendChild(tag);
                                        paintContainer.appendChild(paintTagList);
                                    });
                                }

                                if (tileDescription) {
                                    tileDescription.parentNode.insertBefore(contentTag, tileDescription);
                                    tileDescription.parentNode.insertBefore(paintContainer, tileDescription);
                                    const arrowContainer = document.createElement('div');
                                    arrowContainer.insertAdjacentHTML('beforeend', arrowSVG);
                                    arrowContainer.classList.add('arrowContainer');

                                    paintContainer.appendChild(arrowContainer);
                                }
                            }
                        }

                        const newTitleContainer = document.createElement('div');
                        newTitleContainer.classList.add('titleContainer');
                        const tileTitle = tile.querySelector('.description .h3like');
                        if (tileTitle) {
                            const tileIcon = tile.querySelector('img.avatar');

                            if (tileIcon) {
                                newTitleContainer.insertAdjacentElement('beforeend', tileIcon);
                            }

                            newTitleContainer.insertAdjacentElement('beforeend', tileTitle);

                            contentTag.insertAdjacentElement('afterend', newTitleContainer);
                            tile.classList.add('ob-custom-tile');
                        }
                    }
                });
            }
            // Uberflip Gwl OB-8993 start here 
            const sectionTiles = document.querySelectorAll('#collection-items .collection-section-items .tile');
            if (sectionTiles) {
                sectionTiles.forEach((tile) => {
                    if (!tile.classList.contains('ob-custom-tile')) {
                        let tileContentTag = '';
                        const tilePainTags = [];
                        const dataTags = tile.getAttribute('data-tags');
                        if (dataTags) {
                            //check tile if it has a content tag, then change content tag to match backend
                            contentKeys.forEach((key) => {
                                if (dataTags.search(key) !== -1) {
                                    tileContentTag = contentTags[key];
                                }
                            });

                            //check tile if it has pain point tag, then add to array
                            painKeys.forEach((key) => {
                                if (dataTags.search(key) !== -1) {
                                    tilePainTags.push(paintTags[key]);
                                }
                            });
                        }

                        //create new elements
                        const contentTag = document.createElement('div');
                        const paintContainer = document.createElement('div');
                        const paintTagList = document.createElement('ul');
                        paintTagList.classList.add('paintTagContainer');
                        const timeTag = tile.querySelector('.tile  .description .friendly-timestamp');

                        if (timeTag) {
                            contentTag.innerHTML = tileContentTag;
                            contentTag.classList.add('content-tag');

                            if (tilePainTags.length !== 0) {
                                tilePainTags.forEach((painTag) => {
                                    const tag = document.createElement('li');
                                    tag.appendChild(document.createTextNode(painTag));
                                    tag.classList.add('paintTag');
                                    paintTagList.appendChild(tag);
                                });
                            }

                            const arrowContainer = document.createElement('div');
                            arrowContainer.insertAdjacentHTML('beforeend', arrowSVG);
                            arrowContainer.classList.add('arrowContainer');
                            paintContainer.appendChild(arrowContainer);
                            paintContainer.appendChild(paintTagList);
                            paintContainer.classList.add('paint-content-container');
                            timeTag.parentNode.insertAdjacentElement('beforeend', paintContainer);

                            timeTag.parentNode.replaceChild(contentTag, timeTag);
                        } else {
                            tile.classList.add('no-time-tag');
                            if (!tile.classList.contains('cta')) {
                                contentTag.innerHTML = tileContentTag;
                                contentTag.classList.add('content-tag');

                                paintContainer.classList.add('paint-content-container');

                                const tileDescription = tile.querySelector('.description .h3like');
                                if (tilePainTags.length !== 0) {
                                    tilePainTags.forEach((painTag) => {
                                        const tag = document.createElement('li');
                                        tag.appendChild(document.createTextNode(painTag));
                                        tag.classList.add('paintTag');
                                        paintTagList.appendChild(tag);
                                        paintContainer.appendChild(paintTagList);
                                    });
                                }

                                if (tileDescription) {
                                    tileDescription.parentNode.insertBefore(contentTag, tileDescription);
                                    tileDescription.parentNode.insertBefore(paintContainer, tileDescription);
                                    const arrowContainer = document.createElement('div');
                                    arrowContainer.insertAdjacentHTML('beforeend', arrowSVG);
                                    arrowContainer.classList.add('arrowContainer');

                                    paintContainer.appendChild(arrowContainer);
                                }
                            }
                        }

                        const newTitleContainer = document.createElement('div');
                        newTitleContainer.classList.add('titleContainer');
                        const tileTitle = tile.querySelector('.description .h3like');
                        if (tileTitle) {
                            const tileIcon = tile.querySelector('img.avatar');

                            if (tileIcon) {
                                newTitleContainer.insertAdjacentElement('beforeend', tileIcon);
                            }

                            newTitleContainer.insertAdjacentElement('beforeend', tileTitle);

                            contentTag.insertAdjacentElement('afterend', newTitleContainer);
                            tile.classList.add('ob-custom-tile');
                        }
                    }
                });
            }
            // Uberflip Gwl OB-8993 end here 
        }
    }
};

module.exports = { tileTagging };


// WEBPACK FOOTER //
// ./scriptPartials/tileTagging.js